<template>
  <span>
    <b-button v-if="!withoutButton" size="sm" variant="dark" v-b-modal.modalEventsHistory v-translate>
      Shipping Events History
    </b-button>
    <b-modal size="xl" id="modalEventsHistory" ref="modalEventsHistory" hide-footer @show="getEventsHistory" @hide="eventsHistory = []">
      <div slot="modal-title" v-translate>Shipping Events History</div>
      <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
      <b-table
       :items="eventsHistory"
       :fields="eventsHistoryFields"
       show-empty :empty-text="'There are no results to show'"
      >
        <div slot="table-busy" class="text-center text-danger my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong v-translate>Loading...</strong>
        </div>
        <template v-slot:cell(event)="row">
          {{toTitleCase(row.value)}}
        </template>
        <template v-slot:cell(applied_by)="row">
          <user-card :user="row.value" :profile-picture="false" :with-titles="false" />
        </template>
        <template v-slot:cell(data)="row">
          <ul>
            <li v-for="(value, key) in row.value" :key="key" v-if="value && value.length !== 0 && value !== 'undefined' && value !== null">{{ key }}: <span v-html="!key.includes('phone') ? isJson(value) : value.toString()"></span></li>
          </ul>
        </template>
        <template v-slot:cell(created_at)="row">
          {{moment.utc(row.value).tz($tz).format('L LT')}}
        </template>
        <template v-slot:cell(actions)="row">
          <b-button
            pill
            v-b-modal.modalStaticTrackingMap
            style="padding: .33rem .5rem;"
            size="sm"
            @click.stop="staticTrackingCoords = [{lat: row.item.lat, lng: row.item.lng}]"
          >
            <font-awesome-icon icon="map-marker-alt" size="2x" style="font-size: 18px;vertical-align: middle" />
          </b-button>
        </template>
      </b-table>
    </b-modal>

    <b-modal size="lg" id="modalStaticTrackingMap" ref="modalStaticTrackingMap" hide-footer hide-header @hide="staticTrackingCoords = []">
      <mapbox-static-map :markers="staticTrackingCoords" :size="[700, 700]"></mapbox-static-map>
    </b-modal>
  </span>
</template>

<script>
import MapboxStaticMap from '@/components/Maps/MapboxStaticMap'

export default {
  name: 'ShippingEventsHistory',
  components: {
    MapboxStaticMap
  },
  props: {
    shipping: {
      type: Object,
      required: true
    },
    withoutButton: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      eventsHistoryFields: [
        {
          key: 'event',
          label: this.$gettext('Event')
        },
        {
          key: 'data',
          label: this.$gettext('Data')
        },
        {
          key: 'applied_by',
          label: this.$gettext('By')
        },
        {
          key: 'created_at',
          label: this.$gettext('At')
        },
        {
          key: 'actions',
          label: this.$gettext('Actions')
        }
      ],
      eventsHistory: [],
      staticTrackingCoords: []
    }
  },
  methods: {
    getEventsHistory() {
      const params = {
        includes: ['applied_by'],
        sort: [{
          key: 'created_at',
          direction: 'desc'
        }],
        filter_groups: [
          {
            filters: [
              ['shipping_id', 'eq', this.shipping.id]
            ]
          }
        ]
      }
      this.$http.get(this.$appConfig.api.baseUrl + 'shipping-event-histories', { params })
        .then(response => {
          this.eventsHistory = response.body.data
        })
    }
  }
}
</script>
